"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var styles = function styles(theme) {
  return {
    root: (0, _defineProperty2.default)({
      flexGrow: "1",
      height: theme.mixins.toolbar.minHeight + theme.spacing(3.5)
    }, theme.breakpoints.down("xs"), {
      height: theme.mixins.toolbar.minHeight
    })
  };
};

exports.styles = styles;